module.exports = __webpack_public_path__ + "img/adhesivo_ceramico_para_piezas_de_baja_absorcion.31597d9d.png";